// extracted by mini-css-extract-plugin
export default {"trustpilot":"trustpilot___W8Clg","features":"features___MTWym","feature":"feature___iEMOF"};